import { gql } from "@apollo/client";

export const DISCONNECT_GSC = gql`
  mutation DisconnectGsc($email: String) {
    disconnectGsc(email: $email) {
      success
      message
    }
  }
`;
